export const removeMetadata = (id: string) => {
    if (typeof window === "undefined") {
        return;
    }

    const checkAndRemoveScripts = () => {
        const scriptList = document.querySelectorAll("script[type='application/ld+json']");

        if (scriptList.length === 0) {
            setTimeout(checkAndRemoveScripts, 100);
            return;
        }

        scriptList.forEach(script => {
            const scriptId = script.getAttribute("id");

            if (scriptId === id) {
                script.parentNode?.removeChild(script);
            }
        });
    };

    if (document.readyState === "complete") {
        checkAndRemoveScripts();
    } else {
        window.addEventListener("load", checkAndRemoveScripts);
    }
};

export const injectMetadata = (metadata: string, id: string) => {
    if (typeof window === "undefined") {
        return;
    }

    let scriptTag = document.getElementById(id);
    if (scriptTag) {
        scriptTag.innerHTML = metadata;
    } else {
        scriptTag = document.createElement("script");
        scriptTag.setAttribute("type", "application/ld+json");
        scriptTag.id = id;
        scriptTag.innerHTML = metadata;
        document.head.appendChild(scriptTag);
    }
};

export const setCategoryMetadata = (props: any) => {
    const { subCategories, currentUrl, currentPage } = props;
    let logo = "";
    if (typeof document !== "undefined") {
        logo = document.querySelector(".home-page-link img")?.getAttribute("src") || "";
    }

    const itemListData = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        itemListElement: subCategories?.map((subCategory: any, index: number) => ({
            "@type": "ListItem",
            position: index + 1,
            name: subCategory?.name,
            url: `${currentUrl}${subCategory?.path}`,
        })),
    } as any;

    const breadCrumbListData = {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: subCategories?.map((subCategory: any, index: number) => ({
            "@type": "ListItem",
            position: index + 1,
            name: subCategory?.name,
            item: `${currentUrl}${subCategory?.path}`,
        })),
    } as any;

    const organizationData = {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Granite Group",
        alternateName: "",
        url: `${currentUrl}`,
        logo: `${logo}`,
        sameAs: [""],
    } as any;

    injectMetadata(JSON.stringify(itemListData), "categoryListItemList");
    injectMetadata(JSON.stringify(organizationData), "categoryDetailOrganization");
    if (currentPage && currentPage.type !== "HomePage") {
        injectMetadata(JSON.stringify(breadCrumbListData), "categoryListBreadCrumbList");
    }

    setWebsiteMetadata({ currentUrl });
};

export const setProductMetadata = (props: any) => {
    const {
        productState: { value: product },
        productInfo,
        catalogPageState,
        logo,
        currentUrl,
    } = props;

    const productListData = {
        "@context": "https://schema.org/",
        "@type": "Product",
        name: product?.productNumber,
        image: product?.largeImagePath,
        description: product?.productTitle,
        brand: {
            "@type": "Brand",
            name: product?.brand,
        },
        offers: {
            "@type": "Offer",
            url: catalogPageState.value.uri,
            priceCurrency: "USD",
            price: productInfo.pricing?.actualPrice ?? 0,
        },
    } as any;

    const breadCrums = catalogPageState.value.breadCrumbs;
    const breadCrumbListData = {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: breadCrums?.map((subCategory: any, index: number) => ({
            "@type": "ListItem",
            position: index + 1,
            name: subCategory?.text,
            item: `${currentUrl}${subCategory?.url != null ? subCategory?.url : ""}`,
        })),
    } as any;

    const organizationData = {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Granite Group",
        alternateName: "",
        url: `${currentUrl}`,
        logo: `${logo}`,
        sameAs: [""],
    } as any;

    injectMetadata(JSON.stringify(productListData), "productDetail_ProductSchema");
    injectMetadata(JSON.stringify(breadCrumbListData), "productDetail_BreadCrumbListSchema");
    injectMetadata(JSON.stringify(organizationData), "productDetail_OrganizationSchema");
    setWebsiteMetadata({ currentUrl });
};

export const setProductListMetadata = (props: any) => {
    const { products, catalogPageState, currentUrl } = props;
    let logo = "";
    if (typeof document !== "undefined") {
        logo = document.querySelector(".home-page-link img")?.getAttribute("src") || "";
    }

    const itemListData = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        itemListElement: products?.map((product: any, index: number) => ({
            "@type": "ListItem",
            position: index + 1,
            name: product?.productNumber,
            url: `${product?.uri}`,
        })),
    } as any;

    const breadCrums = catalogPageState.value.breadCrumbs;
    const breadCrumbListData = {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        itemListElement: breadCrums?.map((subCategory: any, index: number) => ({
            "@type": "ListItem",
            position: index + 1,
            name: subCategory?.text,
            item: `${currentUrl}${subCategory?.url != null ? subCategory?.url : ""}`,
        })),
    } as any;

    const organizationData = {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Granite Group",
        alternateName: "",
        url: `${currentUrl}`,
        logo: `${logo}`,
        sameAs: [""],
    } as any;

    injectMetadata(JSON.stringify(itemListData), "productList_itemListSchema");
    injectMetadata(JSON.stringify(breadCrumbListData), "productList_BreadCrumbListSchema");
    injectMetadata(JSON.stringify(organizationData), "productList_OrganizationSchema");
    setWebsiteMetadata({ currentUrl });
};

export const setWebsiteMetadata = (props: any) => {
    // This should be refactored when product search is done, Internal Search URL
    const { currentUrl, searchTerm, searchUrl } = props;
    let logo = "";
    if (typeof document !== "undefined") {
        logo = document.querySelector(".home-page-link img")?.getAttribute("src") || "";
    }
    const websiteData = {
        "@context": "https://schema.org/",
        "@type": "WebSite",
        name: "Granite group",
        url: `${currentUrl}`,
        potentialAction: {
            "@type": "SearchAction",
            target: searchTerm ? `${searchUrl}` : "",
            "query-input": searchTerm ? `required name=${searchTerm}` : "",
        },
    } as any;

    injectMetadata(JSON.stringify(websiteData), "websiteDataSchema");
};
